<template>
  <a-drawer width="55%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>info</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="status">
        <span slot="label">
          <a-tooltip>
            {{ $t('状态') }}<template slot="title">{{ $t('状态') }}</template>
          </a-tooltip>
        </span>
        <custom-dict-tag :options="customDict.CustomRequestStatusEnum" :value="form.status" />
      </a-form-model-item>
      <a-form-model-item v-if="form.status===2" prop="auditReason">
        <span slot="label">
          <a-tooltip>
            {{ $t('原因') }}<template slot="title">{{ $t('原因') }}</template>
          </a-tooltip>
        </span>
        <span>{{ form.auditReason }}</span>
      </a-form-model-item>
      <a-form-model-item prop="demand">
        <span slot="label">
          <a-tooltip>
            {{ $t('采购需求') }}<template slot="title">{{ $t('采购需求') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.demand" type="textarea" :rows="7" :placeholder="$t('请输入')" allow-clear :disabled="true" />
      </a-form-model-item>
      <a-form-model-item>
        <span slot="label">
          <a-tooltip>
            {{ $t('联系信息') }}<template slot="title">{{ $t('联系信息') }}</template>
          </a-tooltip>
        </span>
        <div style="width: 100%; padding: 10px; border: solid #dcdcdc 1px;">
          <a-descriptions :column="1">
            <a-descriptions-item :label="$t('名称类型')">
              <span v-if="form.nameType===1">公司名称</span>
              <span v-else-if="form.nameType===2">工作室名称</span>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('名称')">
              {{ form.name }}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('邮箱')">
              {{ form.email }}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('电话号码')">
              {{ form.mobile }}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('国家及城市')">
              {{ `${form.country}${form.city}` }}
            </a-descriptions-item>
          </a-descriptions>
        </div>
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <!-- 联系客户 -->
          <a-button type="primary" @click="handleShowAccount">
            {{ $t('联系客户') }}
          </a-button>
          <a-button v-if="form.status===0" type="danger" :loading="submitLoading" @click="handleShowReject">
            {{ $t('审核拒绝') }}
          </a-button>
          <a-button v-if="form.status===0" type="primary" :loading="submitLoading" @click="handleSendCoupon">
            {{ $t('发送优惠券') }}
          </a-button>
        </a-space>
      </div>

    </a-form-model>

    <reject-modal
      :visible="rejectModalVisible"
      :onReject="handleBatchReject"
      @cancel="rejectModalVisible = false"
    />
  </a-drawer>
</template>

<script>
import { batchRejectWholesale, getWholesale, openCustomerWork } from '@/api/goods/wholesale'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import RejectModal from '@/components/RejectModal/index.vue'

export default {
  name: 'DetailDialog',
  props: {},
  components: {
    RejectModal,
    CustomDictTag
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        productId: null,

        productName: null,

        productDesc: null,

        quantity: null,

        productMedia: null,

        contactName: null,

        contactEmail: null,

        contactPhone: null,

        country: null,

        city: null,

        status: 0,

        submitTime: null,

        auditTime: null,

        auditUser: null,

        auditReason: null,

        couponId: null,

        couponCount: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        productId: [
          { required: true, message: '商品id，关联商品表' + this.$t('不能为空'), trigger: 'blur' }
        ],
        productName: [
          { required: true, message: '产品名称' + this.$t('不能为空'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态 0:待审核 1:已处理 2:已拒绝' + this.$t('不能为空'), trigger: 'blur' }
        ],
        submitTime: [
          { required: true, message: '提交时间' + this.$t('不能为空'), trigger: 'blur' }
        ]
      },
      rejectModalVisible: false
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    jumpOrder() {

    },
    handleShowAccount(){
      var id = '581487142740697088';
      console.log('打开工作台',id)
      openCustomerWork({"id": id}).then(response => {
        window.open(response.data,"_blank")
      })
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        productId: null,
        productName: null,
        productDesc: null,
        quantity: null,
        productMedia: null,
        contactName: null,
        contactEmail: null,
        contactPhone: null,
        country: null,
        city: null,
        status: 0,
        submitTime: null,
        auditTime: null,
        auditUser: null,
        auditReason: null,
        couponId: null,
        couponCount: null
      }
    },
    handleShow(row) {
      const id = row.id
      getWholesale({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
      })
    },
    handleShowReject() {
      this.rejectModalVisible = true
    },
    handleBatchReject(reason) {
      const data = [this.form.id]
      return batchRejectWholesale({ ids: data, reason: reason })
        .then(() => {
          const id = this.form.id
          getWholesale({ 'id': id }).then(response => {
            this.form = response.data
            this.open = true
          })
          const message = this.$t('拒绝成功')
          this.$message.success(
            message,
            3
          )
          this.rejectId = undefined
          this.rejectModalVisible = false
          this.$emit('ok')
        }).catch(() => {
          this.rejectId = undefined
          this.rejectModalVisible = false
        })
    },
    handleSendCoupon() {
      this.$router.push({
        name: 'Coupon',
      })
    }
  }
}
</script>
